import React from 'react';
import { Box, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Add from '@mui/icons-material/Add';
import Link from '../Link';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    cursor: 'pointer',
    borderRadius: theme.spacing(1),
    margin: 'auto',
    marginBottom: theme.spacing(3),
    overflow: 'hidden',
  },
  emptyState: {
    background: 'var(--empty-state-background-color)',
    textAlign: 'center',
  },
  linkEmpty: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

interface Props {
  label: string;
  onOpenEditor: () => void;
}

const EmptySlotBox: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { label, onOpenEditor } = props;

  return (
    <Box className={classes.container} onClick={onOpenEditor} width="auto">
      <Box className={classes.emptyState} py={1.5}>
        <Link className={classes.linkEmpty} beforeIcon={<Add />} text={label}>
          {label}
        </Link>
      </Box>
    </Box>
  );
};

export default EmptySlotBox;
